import React from "react";
import Introduction from "./Introduction";
import CodeSnippet from "./CodeSnippet";
import About from "../About/About";
import Experience from "../Experience/Experience";
import Projects from "../Projects/Projects";
import Skills from "../Skills/Skills";
import Contact from "../Contact/Contact";

const Home = () => {
  return (
    <>
      <div className="container-fluid d-flex align-items-center min-vh-100 bg-dark text-light">
        <div className="row w-100">
          <div className="col-md-6 d-flex justify-content-center">
            <Introduction />
          </div>
          <div className="col-md-6 d-flex justify-content-center">
            <CodeSnippet />
          </div>
        </div>
      </div>
      <About />
      <Experience />
      <Projects />
      <Skills />
      <Contact />
    </>
  );
};

export default Home;
